const PWYW_DISCOUNTS = {
  0: 'PWYW_100',
  1: 'PWYW_99',
  2: 'PWYW_98',
  3: 'PWYW_97',
  4: 'PWYW_96',
  5: 'PWYW_95',
  6: 'PWYW_94',
  7: 'PWYW_93',
  8: 'PWYW_92',
  9: 'PWYW_91',
  10: 'PWYW_90',
  11: 'PWYW_89',
  12: 'PWYW_88',
  13: 'PWYW_87',
  14: 'PWYW_86',
  15: 'PWYW_85',
  16: 'PWYW_84',
  17: 'PWYW_83',
  18: 'PWYW_82',
  19: 'PWYW_81',
  20: 'PWYW_80',
  21: 'PWYW_79',
  22: 'PWYW_78',
  23: 'PWYW_77',
  24: 'PWYW_76',
  25: 'PWYW_75',
  26: 'PWYW_74',
  27: 'PWYW_73',
  28: 'PWYW_72',
  29: 'PWYW_71',
  30: 'PWYW_70',
  31: 'PWYW_69',
  32: 'PWYW_68',
  33: 'PWYW_67',
  34: 'PWYW_66',
  35: 'PWYW_65',
  36: 'PWYW_64',
  37: 'PWYW_63',
  38: 'PWYW_62',
  39: 'PWYW_61',
  40: 'PWYW_60',
  41: 'PWYW_59',
  42: 'PWYW_58',
  43: 'PWYW_57',
  44: 'PWYW_56',
  45: 'PWYW_55',
  46: 'PWYW_54',
  47: 'PWYW_53',
  48: 'PWYW_52',
  49: 'PWYW_51',
  50: 'PWYW_50',
  51: 'PWYW_49',
  52: 'PWYW_48',
  53: 'PWYW_47',
  54: 'PWYW_46',
  55: 'PWYW_45',
  56: 'PWYW_44',
  57: 'PWYW_43',
  58: 'PWYW_42',
  59: 'PWYW_41',
  60: 'PWYW_40',
  61: 'PWYW_39',
  62: 'PWYW_38',
  63: 'PWYW_37',
  64: 'PWYW_36',
  65: 'PWYW_35',
  66: 'PWYW_34',
  67: 'PWYW_33',
  68: 'PWYW_32',
  69: 'PWYW_31',
  70: 'PWYW_30',
  71: 'PWYW_29',
  72: 'PWYW_28',
  73: 'PWYW_27',
  74: 'PWYW_26',
  75: 'PWYW_25',
  76: 'PWYW_24',
  77: 'PWYW_23',
  78: 'PWYW_22',
  79: 'PWYW_21',
  80: 'PWYW_20',
  81: 'PWYW_19',
  82: 'PWYW_18',
  83: 'PWYW_17',
  84: 'PWYW_16',
  85: 'PWYW_15',
  86: 'PWYW_14',
  87: 'PWYW_13',
  88: 'PWYW_12',
  89: 'PWYW_11',
  90: 'PWYW_10',
  91: 'PWYW_9',
  92: 'PWYW_8',
  93: 'PWYW_7',
  94: 'PWYW_6',
  95: 'PWYW_5',
  96: 'PWYW_4',
  97: 'PWYW_3',
  98: 'PWYW_2',
  99: 'PWYW_1',
};

export default PWYW_DISCOUNTS;
